// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.Header-Container-CLE {
  position: absolute;
  display: flex;
  justify-content: center;
  top: 0;
  width: 100%;
  min-height: 140px;
  align-items: center;
}
@media (max-width: 1300px) {
  .Header-Container-CLE {
    height: auto;
    min-height: 192px;
  }
}
.Header-Container-CLE .Header-upper {
  width: 88.5%;
  z-index: 999;
  background-color: #ffffff;
  height: 100px;
  position: fixed;
  top: 40px;
  /* Posición inicial */
  transition: opacity 0.5s ease;
  /* Transición de opacidad para una transición suave */
  opacity: 1;
  /* Opacidad inicial */
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 79px;
}
@media (max-width: 1300px) {
  .Header-Container-CLE .Header-upper {
    width: 100%;
    top: 0px;
    min-height: 60px;
    height: 60px;
  }
}
.Header-Container-CLE .Header-upper .Grid-Links {
  height: 100%;
  padding: 0 0 0 0;
  margin: 0;
}
@media (max-width: 1150px) {
  .Header-Container-CLE .Header-upper .Grid-Links {
    justify-content: space-between;
  }
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .logo-img {
  max-height: 76px;
  min-height: 76px;
}
@media (max-width: 1300px) {
  .Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .logo-img {
    max-height: 55px;
    min-height: 55px;
  }
}
@media (max-width: 900px) {
  .Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .logo-img {
    max-height: 45px;
    min-height: 45px;
  }
}
@media (max-width: 600px) {
  .Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .logo-img {
    max-height: 30px;
    min-height: 30px;
  }
}
@media (max-width: 1150px) {
  .Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header.logo-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Grid-links-uls {
  width: 100%;
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Grid-links-uls ul {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  margin: 0;
  padding: 0;
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Grid-links-uls ul .Enlace-linked {
  text-decoration: none;
  cursor: pointer;
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Grid-links-uls ul .Enlace-linked :hover {
  transform: translateY(-2%);
  color: #b3282d;
}
@media (max-width: 1150px) {
  .Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Grid-links-uls {
    display: none;
  }
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .button-closed {
  padding: 0;
  border: none;
  background: none;
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Phone-Whats-Item {
  background-color: #b3282d;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Phone-Whats-Item a {
  cursor: pointer;
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Phone-Whats-Item a :hover {
  transform: translateY(-5%);
}
@media (max-width: 1150px) {
  .Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .Phone-Whats-Item {
    display: none;
  }
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .hamburguer {
  display: none;
}
@media (max-width: 1150px) {
  .Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .hamburguer {
    display: inline;
  }
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .hamburguer button {
  background-color: #ffffff;
  border: none;
}
.Header-Container-CLE .Header-upper .Grid-Links .Grid-Items-Header .hamburguer button hr {
  background-color: #b3282d;
  width: 24px;
  border: none;
  height: 3px;
}
.Header-Container-CLE .Menu-Hamburguer-Superior {
  background-color: #ffffff;
  width: 100%;
  z-index: 999999999999999;
  position: fixed;
  transform: translateX(0%);
  transition: transform 4.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5em 0;
  margin-top: 7em;
  display: none;
}
.Header-Container-CLE .Menu-Hamburguer-Superior button {
  position: absolute;
  top: 10px;
  right: 13px;
  border: none;
  background-color: rgba(255, 255, 255, 0);
}
.Header-Container-CLE .Menu-Hamburguer-Superior .Menu-hamburguer {
  width: 90%;
  margin: 0;
}
.Header-Container-CLE .Menu-Hamburguer-Superior .Menu-hamburguer ul {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  margin: 0;
  padding: 0;
}
.Header-Container-CLE .Menu-Hamburguer-Superior .Menu-hamburguer ul .Enlace-linked {
  text-decoration: none;
  margin: 0.5em auto;
  cursor: pointer;
}
.Header-Container-CLE .Menu-Hamburguer-Superior .Menu-hamburguer ul .Enlace-linked :hover {
  transform: translateY(-2%);
  color: #b3282d;
}
.Header-Container-CLE .Menu-Hamburguer-Superior .Menu-hamburguer .Phone-Whats-Item-2 {
  display: none;
}
@media (max-width: 1000px) {
  .Header-Container-CLE .Menu-Hamburguer-Superior .Menu-hamburguer .Phone-Whats-Item-2 {
    margin-top: 12px;
    padding: 3px 0;
    background-color: #b3282d;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
  }
  .Header-Container-CLE .Menu-Hamburguer-Superior .Menu-hamburguer .Phone-Whats-Item-2 a {
    cursor: pointer;
  }
  .Header-Container-CLE .Menu-Hamburguer-Superior .Menu-hamburguer .Phone-Whats-Item-2 a :hover {
    transform: translateY(-5%);
  }
}
@media (max-width: 1150px) {
  .Header-Container-CLE .Menu-Hamburguer-Superior {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Header/Header.scss","webpack://./src/utils/scss/Constants.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,MAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAAF;AAEE;EATF;IAUI,YAAA;IACA,iBAAA;EACF;AACF;AACE;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,qBAAA;EACA,6BAAA;EACA,qDAAA;EACA,UAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AACJ;AACI;EAjBF;IAkBI,WAAA;IACA,QAAA;IACA,gBAAA;IACA,YAAA;EAEJ;AACF;AAAI;EACE,YAAA;EACA,gBAAA;EACA,SAAA;AAEN;AAAM;EALF;IAMI,8BAAA;EAGN;AACF;AADM;EACE,SAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAGR;AADQ;EACE,gBAAA;EACA,gBAAA;AAGV;AAAQ;EACE;IACE,gBAAA;IACA,gBAAA;EAEV;AACF;AACQ;EACE;IACE,gBAAA;IACA,gBAAA;EACV;AACF;AAEQ;EACE;IACE,gBAAA;IACA,gBAAA;EAAV;AACF;AAIU;EADF;IAEI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,uBAAA;EADV;AACF;AAIQ;EACE,WAAA;AAFV;AAIU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;AAFZ;AAIY;EACE,qBAAA;EACA,eAAA;AAFd;AAIc;EACE,0BAAA;EACA,cC3DI;ADyDpB;AAOU;EAtBF;IAuBI,aAAA;EAJV;AACF;AAOQ;EACE,UAAA;EACA,YAAA;EACA,gBAAA;AALV;AAQQ;EACE,yBC3EqB;ED4ErB,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AANV;AAQU;EACE,eAAA;AANZ;AAQY;EACE,0BAAA;AANd;AAUU;EAjBF;IAkBI,aAAA;EAPV;AACF;AAUQ;EACE,aAAA;AARV;AAUU;EAHF;IAII,eAAA;EAPV;AACF;AASU;EACE,yBAAA;EACA,YAAA;AAPZ;AASY;EACE,yBClHG;EDmHH,WAAA;EACA,YAAA;EACA,WAAA;AAPd;AAeE;EACE,yBAAA;EACA,WAAA;EACA,wBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;AAbJ;AAeI;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;AAbN;AAgBI;EACE,UAAA;EACA,SAAA;AAdN;AAgBM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,UAAA;AAdR;AAgBQ;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AAdV;AAgBU;EACE,0BAAA;EACA,cCtKK;ADwJjB;AAmBM;EACE,aAAA;AAjBR;AAmBQ;EAHF;IAII,gBAAA;IACA,cAAA;IACA,yBCjLO;IDkLP,YAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,6BAAA;IACA,WAAA;EAhBR;EAkBQ;IACE,eAAA;EAhBV;EAkBU;IACE,0BAAA;EAhBZ;AACF;AAsBI;EAvEF;IAwEI,aAAA;EAnBJ;AACF","sourcesContent":["@import \"~/src/utils/scss/index.scss\";\n\n.Header-Container-CLE {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  top: 0;\n  width: 100%;\n  min-height: 140px;\n  align-items: center;\n\n  @media (max-width: 1300px) {\n    height: auto;\n    min-height: 192px;\n  }\n\n  .Header-upper {\n    width: 88.5%;\n    z-index: 999;\n    background-color: #ffffff;\n    height: 100px;\n    position: fixed;\n    top: 40px;\n    /* Posición inicial */\n    transition: opacity 0.5s ease;\n    /* Transición de opacidad para una transición suave */\n    opacity: 1;\n    /* Opacidad inicial */\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    min-height: 79px;\n\n    @media (max-width: 1300px) {\n      width: 100%;\n      top: 0px;\n      min-height: 60px;\n      height: 60px;\n    }\n\n    .Grid-Links {\n      height: 100%;\n      padding: 0 0 0 0;\n      margin: 0;\n\n      @media (max-width: 1150px) {\n        justify-content: space-between;\n      }\n\n      .Grid-Items-Header {\n        margin: 0;\n        padding: 0;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        height: 100%;\n\n        .logo-img {\n          max-height: 76px;\n          min-height: 76px;\n        }\n\n        @media (max-width: 1300px) {\n          .logo-img {\n            max-height: 55px;\n            min-height: 55px;\n          }\n        }\n\n        @media (max-width: 900px) {\n          .logo-img {\n            max-height: 45px;\n            min-height: 45px;\n          }\n        }\n\n        @media (max-width: 600px) {\n          .logo-img {\n            max-height: 30px;\n            min-height: 30px;\n          }\n        }\n\n        &.logo-container {\n          @media (max-width: 1150px) {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            justify-content: center;\n          }\n        }\n\n        .Grid-links-uls {\n          width: 100%;\n\n          ul {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            justify-content: space-evenly;\n            margin: 0;\n            padding: 0;\n\n            .Enlace-linked {\n              text-decoration: none;\n              cursor: pointer;\n\n              :hover {\n                transform: translateY(-2%);\n                color: $color_texto_hover; //#b3282d;\n              }\n            }\n          }\n\n          @media (max-width: 1150px) {\n            display: none;\n          }\n        }\n\n        .button-closed {\n          padding: 0;\n          border: none;\n          background: none;\n        }\n\n        .Phone-Whats-Item {\n          background-color: $color_background_phone_whats; // #b3282d;\n          height: 100%;\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          justify-content: space-evenly;\n          width: 100%;\n\n          a {\n            cursor: pointer;\n\n            :hover {\n              transform: translateY(-5%);\n            }\n          }\n\n          @media (max-width: 1150px) {\n            display: none;\n          }\n        }\n\n        .hamburguer {\n          display: none;\n\n          @media (max-width: 1150px) {\n            display: inline;\n          }\n\n          button {\n            background-color: #ffffff;\n            border: none;\n\n            hr {\n              background-color: $color_principa;\n              width: 24px;\n              border: none;\n              height: 3px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .Menu-Hamburguer-Superior {\n    background-color: #ffffff;\n    width: 100%;\n    z-index: 999999999999999;\n    position: fixed;\n    transform: translateX(0%);\n    transition: transform 4.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1.5em 0;\n    margin-top: 7em;\n    display: none;\n\n    button {\n      position: absolute;\n      top: 10px;\n      right: 13px;\n      border: none;\n      background-color: #ffffff00;\n    }\n\n    .Menu-hamburguer {\n      width: 90%;\n      margin: 0;\n\n      ul {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: space-evenly;\n        margin: 0;\n        padding: 0;\n\n        .Enlace-linked {\n          text-decoration: none;\n          margin: 0.5em auto;\n          cursor: pointer;\n\n          :hover {\n            transform: translateY(-2%);\n            color: $color_principa;\n          }\n        }\n      }\n\n      .Phone-Whats-Item-2 {\n        display: none;\n\n        @media (max-width: 1000px) {\n          margin-top: 12px;\n          padding: 3px 0;\n          background-color: $color_principa;\n          height: 100%;\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          justify-content: space-evenly;\n          width: 100%;\n\n          a {\n            cursor: pointer;\n\n            :hover {\n              transform: translateY(-5%);\n            }\n          }\n        }\n      }\n    }\n\n    @media (max-width: 1150px) {\n      display: flex;\n    }\n  }\n}","// Header \n$Moon: \"../../../assets/img/CiudadLaEncantada_Moon.png\";\n$Sun: \"../../../assets/img/CiudadLaEncantada_Sun.png\";\n$Header_Section_Background: \"../../assets/img/CIUDAD_ENCANTADA_HEADER_SECTION_BACKGROUND.png\";\n\n// Desarrollo\n$Desarrollo_Backgroud: \"../../assets/img/CIUDAD_ENCANTADA_CLEDESARROLLO_BACKGROUND.png\";\n\n// Galeria \n$Galeria_Backgroud : \"../../assets/img/CIUDAD_ENCANTALA_GALERIA_BACKGROUND.png\";\n\n// Infraestructura\n$Infraestructura_Background: \"../../assets/img/CIUDAD_ENCANTADA_BACKGROUND.png\";\n\n// Amenidades\n$ParqueCentral: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_PARQUE_CENTRAL.png\";\n$ParqueCentralHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_PARQUE_CENTRAL_HOVER.png\";\n$PlazaComercial: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_PLAZAS_COMERCIALES.jpeg\";\n$PlazaComercialHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_PLAZAS_COMERCIALES_HOVER.png\";\n$Colegio: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_COLEGIO.png\";\n$ColegioHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_COLEGIO_HOVER.png\";\n$AreaVerde: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_AREA_VERDE.jpeg\";\n$AreaVerdeHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_AREA_VERDE_HOVER.png\";\n$Restaurante: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_RESTAURANTES.png\";\n$RestauranteHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_RESTAURANTESHOVER.png\";\n$Servicios: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_SERVICIOS.jpeg\";\n$ServiciosHover: \"../../assets/img/CIUDAD_ENCANTADA_AMENIDADES_SERVICIOS_HOVER.png\";\n\n// Presentacion\n$Presentacion_Background: \"../../assets/img/CIUDAD_ENCANTADA_BACKGROUND.png\";\n\n// Tamaños terrenos\n$Map : \"../../assets/img/Ciudadlaencantada_Map.png\";\n$Tamaños_Render1 : \"../../assets/img/CIUDAD_ENCANTADA_TAMANOS_RENDER1.png\";\n$Tamaños_Render2: \"../../assets/img/CIUDAD_ENCANTADA_TAMANOS_RENDER2.png\";\n$Tamaños_Render3: \"../../assets/img/CIUDAD_ENCANTADA_TAMANOS_RENDER3.png\";\n\n// Ubicacion \n$Ubicacion_Background: \"../../assets/img/CIUDAD_ENCANTADA_BACKGROUND.png\";\n$Ubicacion_Mapa: \"../../assets/img/CIUDAD_ENCANTADA_UBICACION_BACKGROUND_MAPA.png\";\n\n// Formulacio contacto\n$Form_Contacto: \"../../assets/img/CIUDAD_ENCANTADA_CONTACTO_BACKGROUND_FORMULARIO.png\";\n\n// HEX = b3282d\n// Color de la pagina \n$color_principa: #b3282d;\n$color_botones: #b3282d;\n$color_botones2: #fff;\n$color_border_switch_header: #b3282d;\n$color_switch-knob_header: #b3282d;\n$color_texto_hover: #b3282d;\n$color_background_phone_whats: #b3282d;\n$color_footer: #b3282d;\n\n// Formulario\n$color_formulario_1: #bc4f53;\n$color_formulario_2: #b3282d;\n\n// Tabla Disponibilidad\n$color_tabla_1: #b3282d;\n$color_tabla_2: #e7cbcc;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
